export default __webpack_public_path__ + "close.c4842ff5.svg";